// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".accordion-enter-active[data-v-476e5e90],.accordion-leave-active[data-v-476e5e90]{overflow:clip;will-change:height,opacity}.expanded-border[data-v-476e5e90]{border:solid;border-color:#4d64ff}.accordion-enter[data-v-476e5e90],.accordion-leave-to[data-v-476e5e90]{height:0!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
